/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 * 
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 * 
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains the hook used to retrieve the Theme Manager Context.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/**
 * Hook to allow for the execution of side effects.
 */
import { useEffect } from 'react';

/**
 * Hook to get access to the react-router state.
 */
import { useHistory } from 'react-router-dom';

/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

/**
 * Enables the use of version data loaded from the ServiceStack API.
 */
import { useVersionSelector, VersionSelectors } from 'src/store/reducers/version';

/**
 * Typings
 */
import * as Dtos from '../api/dtos';

/*
 * ---------------------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------------------
 */

const useVersionCheck = (version: Dtos.Version | null) => {
    const history = useHistory();
    const currentVersion = useVersionSelector(VersionSelectors.selectVersion);

    useEffect(() => {
        if (currentVersion &&
            version &&
            currentVersion.id !== version.id) {
                history.replace('/error/404');
            }
    }, [currentVersion && version])
}

/*
 * ---------------------------------------------------------------------------------
 * Exports - Default
 * ---------------------------------------------------------------------------------
 */

export default useVersionCheck;


// WEBPACK FOOTER //
// ./src/hooks/useVersionCheck.ts